import {Component, ViewChild}           from '@angular/core';
import {NgbCalendar,
	NgbDatepickerConfig, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";



@Component({
	selector: 'datepicker-single',
	template: `
	<ngb-datepicker #dp ngModel (ngModelChange)="onDateChange($event)" [firstDayOfWeek]="7"></ngb-datepicker>
	`,
	providers: [NgbDatepickerConfig],
})


/**
 * A single-month calendar that exports a selectedDate
 * variable.
 */
export class DatepickerSingleComponent {


	selectedDate: NgbDateStruct = null;


	/**
	 * Initialize the calendar settings.
	 *
	 * @param config    The calendar configuration object.
	 * @param calendar  The calendar object.
	 */
	constructor(config: NgbDatepickerConfig,
	            calendar: NgbCalendar,) {

		this.selectedDate = calendar.getToday();
		let cDate: Date = new Date();
		config.maxDate = {'day': cDate.getDate(), 'month': cDate.getMonth() + 1, 'year': cDate.getFullYear()};
		config.outsideDays = "hidden";

	}


	/**
	 * Lets me talk to the datepicker Object.
	 */
	@ViewChild('dp')
	dp: any;


	/**
	 * Update selectedDate whenever the user
	 * clicks on a date in the displayed calendar.
	 *
	 * @param {NgbDateStruct} choice  The selected date value.
	 */
	onDateChange(choice: NgbDateStruct): void {

		this.selectedDate = choice;

	}

}



// WEBPACK FOOTER //
// ./src/app/articles/feed/news/datepicker-single/datepicker-single.component.ts